import React, { useState, useRef } from 'react';
import { useBlog } from '../../context/BlogContext';

export default function MediaUploader() {
  const { addMedia, uploadAndAddMedia } = useBlog();
  const [urlInput, setUrlInput] = useState('');
  const [dragover, setDragover] = useState(false);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const addFromUrl = async () => {
    if (!urlInput.trim()) return;
    try {
      await addMedia({
        url: urlInput.trim(),
        filename: urlInput.split('/').pop() || 'image',
        type: 'image',
      });
      setUrlInput('');
    } catch (e) {
      alert('No se pudo añadir la imagen por URL.');
    }
  };

  // Sube cada archivo (imagen o video mp4) a S3/R2 (ya no se guarda base64).
  const handleFiles = async (files) => {
    const valid = Array.from(files).filter(
      f => f.type.startsWith('image/') || f.type.startsWith('video/')
    );
    if (!valid.length) return;
    setUploading(true);
    try {
      for (const file of valid) {
        await uploadAndAddMedia(file);
      }
    } catch (e) {
      alert('Falló la subida de un archivo. ¿Sesión de admin caducada?');
    } finally {
      setUploading(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragover(false);
    if (e.dataTransfer.files.length) handleFiles(e.dataTransfer.files);
  };

  return (
    <div>
      <div
        className={`adminblog-upload-zone ${dragover ? 'dragover' : ''}`}
        onDragOver={(e) => { e.preventDefault(); setDragover(true); }}
        onDragLeave={() => setDragover(false)}
        onDrop={handleDrop}
        onClick={() => fileRef.current?.click()}
      >
        <p>{uploading ? 'Subiendo…' : 'Drop images or videos here or click to upload'}</p>
        <span>Imágenes (JPG, PNG, AVIF, WebP) y video MP4</span>
        <input
          ref={fileRef}
          type="file"
          accept="image/*,video/mp4,video/*"
          multiple
          style={{ display: 'none' }}
          onChange={(e) => handleFiles(e.target.files)}
        />
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        <input
          type="text"
          value={urlInput}
          onChange={(e) => setUrlInput(e.target.value)}
          placeholder="Or paste image URL..."
          style={{ flex: 1, padding: '10px 12px', border: '1px solid #e5e5e5', borderRadius: 6, fontSize: 13 }}
          onKeyDown={(e) => e.key === 'Enter' && addFromUrl()}
        />
        <button
          onClick={addFromUrl}
          style={{ padding: '10px 16px', background: '#333', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer' }}
        >
          Add
        </button>
      </div>
    </div>
  );
}
